import { trackEvent } from 'lib/analytics';

interface StarRatingProps {
  productSku: string;
}

export const StarRating = ({ productSku }: StarRatingProps) => {
  const clickStarRatingHandler = () => {
    // the div containing the star rating is wide, so we want to be sure that
    // the event only fires if the user clicked the star rating. when the user
    // clicks it, the page scrolls down
    const startScrollY = window.scrollY;

    setTimeout(() => {
      const endScrollY = window.scrollY;
      if (endScrollY > startScrollY) {
        trackEvent('Reviews Link Clicked', {
          location: 'Hero',
        });
      }
    }, 100);
  };

  return (
    <div
      onClick={clickStarRatingHandler}
      className='yotpo-widget-instance'
      data-yotpo-instance-id={process.env.NEXT_PUBLIC_YOTPO_REVIEWS_WIDGET_INSTANCE_ID?.toString()}
      data-yotpo-product-id={productSku}
    />
  );
};
